import React from 'react';
import { ExtendedContentContainer, ExtendedContentType } from 'components/ExtendedContent/ExtendedContentContainer';
import WordMeaning from 'components/WordMeaning';

export const WordMeaningModalComponent = ({ wordGridResource, defaultWord }) => {
  return <ExtendedContentContainer extendedContentType={ExtendedContentType.WordGrid}>
    <WordMeaning dataList={wordGridResource} defaultWord={defaultWord} />
  </ExtendedContentContainer>
};
